module.exports = __webpack_public_path__ + "static/media/blueLightning.be8b00bd.svg";